import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IGovMediaImportStatusVm } from '../gov-media-import-status-vm.model';

/**
 * /GovMediaFilesForQuestions: the ministry media package (ZIP with the films and photos of the exam
 * questions). POST streams the archive and starts the import on the server; GET follows its progress.
 */
@Injectable({ providedIn: 'root' })
export class GovMediaFilesForQuestionsService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/GovMediaFilesForQuestions`;
  }

  /** Status of the import running now, or of the last one since the API started. */
  get(): Observable<IGovMediaImportStatusVm> {
    const headers = this.createHeaders();
    return this.http.get<IGovMediaImportStatusVm>(this.baseUrl, { headers });
  }

  /**
   * Uploads the archive as multipart/form-data (field "file"). Emits the upload progress events and,
   * once the server has the whole file, the first status of the import it started.
   */
  upload(file: File): Observable<HttpEvent<IGovMediaImportStatusVm>> {
    const headers = this.createHeaders();
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post<IGovMediaImportStatusVm>(this.baseUrl, formData, {
      headers,
      reportProgress: true,
      observe: 'events',
    });
  }

  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
